export const LAST_ACTIVITY_UPDATE_PERIOD = 60 * 1000;
